import { render } from "./Configure.vue?vue&type=template&id=252b552e&scoped=true"
import script from "./Configure.vue?vue&type=script&lang=js"
export * from "./Configure.vue?vue&type=script&lang=js"

import "./Configure.vue?vue&type=style&index=0&id=252b552e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-252b552e"

export default script